import { render, staticRenderFns } from "./ManterParametrosComprovacaoView.vue?vue&type=template&id=41a8eb60&"
import script from "./ManterParametrosComprovacaoView.vue?vue&type=script&lang=js&"
export * from "./ManterParametrosComprovacaoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCol,VContainer,VDataTable,VForm})
